import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./tooltip-legends-collection.json";
import data from "./tooltip-legends-data.json";

export const TooltipLegendsThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
